/**
 * Catalog registry — maps every supported locale to its message catalog.
 *
 * `fr` is the source (and the type origin); `en` and `ar` are declared against
 * `TranslationKeys`, so this object is guaranteed to be complete and structurally
 * parallel at compile time. The runtime (`useT`) reads the active locale's
 * catalog and falls back to `catalogs.fr` for any key it cannot resolve.
 */

import type { Locale } from '../config';

import ar from './ar';
import en from './en';
import fr, { type TranslationKeys } from './fr';

export const catalogs: Record<Locale, TranslationKeys> = { fr, en, ar };

export type { TranslationKeys };
